export default "__VITE_ASSET__a7b32395__"